"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FetchEcommerceImportDetails = exports.FetchEcommerceImportDetailsActionTypes = exports.FetchEcommerceImportStatusActionTypes = exports.EcommerceImportActionTypes = void 0;

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var _actions = require("settings-ui-lib/utils/actions");

var EcommerceImportActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_IMPORT_STATUS: null,
  FETCH_IMPORT_DETAILS: null
}, 'ecommerce-import');
exports.EcommerceImportActionTypes = EcommerceImportActionTypes;
var FetchEcommerceImportStatusActionTypes = (0, _actions.createRequestTypes)(EcommerceImportActionTypes.FETCH_IMPORT_STATUS);
exports.FetchEcommerceImportStatusActionTypes = FetchEcommerceImportStatusActionTypes;
var FetchEcommerceImportDetailsActionTypes = (0, _actions.createRequestTypes)(EcommerceImportActionTypes.FETCH_IMPORT_DETAILS);
exports.FetchEcommerceImportDetailsActionTypes = FetchEcommerceImportDetailsActionTypes;
var FetchEcommerceImportDetails = (0, _actions.createRequestActions)(FetchEcommerceImportDetailsActionTypes);
exports.FetchEcommerceImportDetails = FetchEcommerceImportDetails;